import React from 'react';
import styled from 'styled-components';
import { BarChart2, ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const StatsContainer = styled.section`
  max-width: 1024px;
  margin: 0 auto;
  background: linear-gradient(135deg, #1a365d 0%, #2d3748 100%);
  padding: 4rem 2rem;
  border-radius: 12px;
  color: white;
`;

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const TextContent = styled.div`
  flex: 1;
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 1.75rem;
  }
`;

const Description = styled.p`
  font-size: 1.125rem;
  color: #e2e8f0;
  margin-bottom: 2rem;
  line-height: 1.6;
  max-width: 600px;
`;

const StatsButton = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background-color: #4299e1;
  color: white;
  padding: 1rem 2rem;
  border-radius: 8px;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: #3182ce;
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  svg {
    transition: transform 0.3s ease;
  }

  &:hover svg {
    transform: translateX(4px);
  }
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  
  svg {
    width: 120px;
    height: 120px;
    color: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const BackgroundDecoration = styled.div`
  position: absolute;
  top: -50%;
  right: -10%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(66, 153, 225, 0.1) 0%, rgba(66, 153, 225, 0) 70%);
  border-radius: 50%;
  pointer-events: none;
`;

const StatisticsNavigation = () => {
  const { t } = useTranslation();

  return (
    <StatsContainer>
      <BackgroundDecoration />
      <ContentWrapper>
        <TextContent>
          <Title>{t('statistics-comp.title')}</Title>
          <Description>
            {t('statistics-comp.description')}
          </Description>
          <StatsButton href="/macro-eco">
            {t('statistics-comp.button')}
            <ArrowRight size={20} />
          </StatsButton>
        </TextContent>
        <IconContainer>
          <BarChart2 />
        </IconContainer>
      </ContentWrapper>
    </StatsContainer>
  );
};

export default StatisticsNavigation;